import type * as React from 'react';
import { get } from '@Domain/Api';
import aiCostCallsFetched, {
	type AiCostCallsFetchedAction,
	type AiCostCallsFetchedPayload,
} from '@Application/AiCosts/Actions/aiCostCallsFetched';
import aiCostCallsFetchFailed, {
	type AiCostCallsFetchFailedAction,
} from '@Application/AiCosts/Actions/aiCostCallsFetchFailed';
import type FetchAiCostCalls from '@Application/AiCosts/Queries/FetchAiCostCalls';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AiCostCallsFetchedAction | AiCostCallsFetchFailedAction;

export default (query: FetchAiCostCalls) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Server-side pagination: `get` is used deliberately, never `getPaginated`, so `totalRecords`
			// stays the true total.
			const baseUrl = `${parameters.api.host}/api/accounts/${query.accountId}/ai-costs/calls`;
			const queryString = query.toQueryString();
			const url = queryString.length > 0 ? `${baseUrl}?${queryString}` : baseUrl;

			const payload = await get<AiCostCallsFetchedPayload>(url);

			const action = aiCostCallsFetched(payload, query.accountId, query.queryKey, query.page);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiCostCallsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
